import payloadLoadedAction from "../actions/payloadLoadedAction";

// a thunk is basically a way of taking some async function (like requesting an api result) and wrapping it in a
// function, thus delegating the call until later. We've wrapped this in a promise so that we can resolve once
// the api result is stored into state, which allows us to delay rendering until the data is loaded (see index.js)
const loadDataThunk = () => {
    return (dispatch) => {
        // return a new promise that we can call .then() on
        return new Promise((resolve, reject) => {
            // fetch the remote JSON data
            fetch('https://demo-dot-interactive-fifteen85.appspot.com/api/v1/demo/interactive').then(resp => {
                // fetch API enforces the following stupidity
                resp.json().then(payload => {
                    // store the returned result in the state
                    dispatch(payloadLoadedAction(payload));
                    //resolve the promise, calling any listening callbacks
                    resolve();
                })
            });
        });
    }
};

export default loadDataThunk;


// WEBPACK FOOTER //
// ./src/thunks/loadDataThunk.js